import { LayoutType, withLayout } from 'hocs/with-layout';
import { FinalOnboardingModal } from './final-onboarding-modal';

const WrappedOnboardingFinalScreen = withLayout(
  LayoutType.WithOldNavOnly,
  FinalOnboardingModal,
);

export { WrappedOnboardingFinalScreen as FinalOnboardingModal };
